import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import PropTypesImmutable from 'react-immutable-proptypes';
import {
  ConsumptionPointAdd as AddForm,
  RegisterMeasurementAdd,
  AddConsumer,
} from '../../forms';
import * as actions from '../../actions/actionCreators/consumptionPointActionCreators';
import { Button, Modal, Form } from 'antd';
import {
  MeasurementTable,
  AutoCompleteConsumers,
  FormActions,
  ConsumerInfoTable,
  TableActions,
  AutoCompleteSellers,
} from '../../components';
import {
  getAddConsumptionPointConsumerModal,
  hideAddConsumptionPointConsumerModal,
  showAddConsumptionPointConsumerModal,
} from '../../actions/actionCreators/modalsActionCreators';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { consumerFields } from '../../constants/consumer';
import { gas, meteringPointFields } from '../../constants/meteringPoint';
import { meteringPointDataSource } from '../../constants/classificators';
import * as selectors from '../../reducers/consumptionPointAddReducer';
import { getRole, getUserLegalEntityId } from '../../reducers/userReducer';
import { isAdmin as isUserAdmin } from '../../utils/roles';
import { formValueSelector } from '../../reducers/reactFinalFormReducer';
import { FORM_ADD_CONSUMPTION_POINT } from '../../constants/formKeys';
const FormItem = Form.Item;

class ConsumptionPointAdd extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    points: PropTypesImmutable.list.isRequired,
    selectPoint: PropTypes.func.isRequired,
    selectedPointId: PropTypes.string.isRequired,
    fetchAvpPoints: PropTypes.func.isRequired,
    userRole: PropTypes.string.isRequired,
    createFormVisible: PropTypes.bool.isRequired,
    closePointForm: PropTypes.func.isRequired,
    showPointForm: PropTypes.func.isRequired,
    submitPointForm: PropTypes.func.isRequired,
    consumer: PropTypesImmutable.map,
    consumerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fetchConsumer: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    showConsumerModal: PropTypes.func.isRequired,
    hideConsumerModal: PropTypes.func.isRequired,
    consumerModalVisible: PropTypes.bool.isRequired,
    selectOwner: PropTypes.func.isRequired,
    ownerId: PropTypes.number,
    legalEntityId: PropTypes.number,
    resetFields: PropTypes.func.isRequired,
  };

  state = { editData: null, editConsumerData: null };

  setFormApi = (form) => {
    this._formApi = form;
  };

  handleSave = () => {
    if (this._formApi) {
      this._formApi.submit();
    }
  };

  handleStartAddConsumer = () => {
    this.setState({ editConsumerData: null });
    this.props.showConsumerModal();
  };

  handleStartEditConsumer = (values) => {
    this.setState({ editConsumerData: values });
    this.props.showConsumerModal();
  };

  handleHideConsumerModal = () => {
    this.setState({ editConsumerData: null });
    this.props.hideConsumerModal();
  };

  componentDidMount = () => {
    const { resetFields } = this.props;

    resetFields();
  };

  handleAddPoint = () => {
    this.setState({ editData: null });
    this.props.showPointForm();
  };

  handleEditPoint = (data) => {
    this.setState({ editData: data?.toJS ? data.toJS() : data });
    this.props.showPointForm();
  };

  handleClosePointForm = () => {
    this.setState({ editData: null });
    this.props.closePointForm();
  };

  handlePointSubmit = (values) => this.props.submitPointForm(values);

  componentDidUpdate = (prevProps) => {
    const { consumer: prevConsumer } = prevProps;
    const { fetchAvpPoints, consumer } = this.props;

    if (
      !consumer.isEmpty() &&
      consumer.get(consumerFields.EICX_CODE) !==
        prevConsumer.get(consumerFields.EICX_CODE)
    )
      fetchAvpPoints({ eicxCode: consumer.get(consumerFields.EICX_CODE) });
  };

  render() {
    const {
      t,
      points,
      selectedPointId,
      selectPoint,
      userRole,
      createFormVisible,
      consumerId,
      fetchConsumer,
      isLoading,
      consumer,
      consumerModalVisible,
      legalEntityId,
      selectOwner,
      ownerId,
      selectedGas,
    } = this.props;

    const isAdmin = isUserAdmin(userRole);

    return (
      <React.Fragment>
        <h1>{t('info.title')}</h1>
        <h2>{t('info.consumerTitle')}</h2>
        {!legalEntityId && (
          <FormItem layout="vertical" label={t('info.ownerSearch')}>
            <AutoCompleteSellers value={ownerId} onChange={selectOwner} />
          </FormItem>
        )}
        {(ownerId || legalEntityId) && (
          <React.Fragment>
            <FormItem layout="vertical" label={t('info.consumerSearch')}>
              <AutoCompleteConsumers
                value={typeof consumerId === 'string' ? null : consumerId}
                onChange={fetchConsumer}
              />
            </FormItem>
            <ConsumerInfoTable
              consumer={consumer.isEmpty() ? null : consumer.toJS()}
              onEdit={this.handleStartEditConsumer}
              isAdmin={isAdmin}
            />
            <TableActions>
              <Button onClick={this.handleStartAddConsumer}>
                {t('info.addConsumerBtn')}
              </Button>
            </TableActions>
          </React.Fragment>
        )}
        {consumerId && (
          <React.Fragment>
            <h2>{t('info.pointTitle')}</h2>
            <AddForm
              t={t}
              consumer={consumer}
              ownerId={ownerId || legalEntityId}
              formApiRef={this.setFormApi}
            />
            {(selectedGas === gas.BIOMETHANE ||
              selectedGas === gas.LIQUID_BIOMETHANE) && (
              <MeasurementTable
                t={t}
                data={points.toJS()}
                onSelectMeasurement={selectPoint}
                selectedMeasurementId={selectedPointId}
                onEditClick={this.handleEditPoint}
                isAdmin={isAdmin}
                isEditMode={false}
                isLoading={isLoading}
              />
            )}
            {createFormVisible ? (
              <RegisterMeasurementAdd
                initialValues={this.state.editData || {}}
                closeForm={this.handleClosePointForm}
                t={t}
                inEditForNotAdmin={false}
                isAdmin={isAdmin}
                onSubmit={this.handlePointSubmit}
              />
            ) : (
              <React.Fragment>
                {points
                  .filter(
                    (point) =>
                      point.get(meteringPointFields.DATA_SOURCE) ===
                      meteringPointDataSource.VIRTUAL
                  )
                  .isEmpty() &&
                  selectedGas === gas.HYDROGEN && (
                    <div className="register-measurement-container__add-button">
                      <Button onClick={this.handleAddPoint} type="primary">
                        {t('measurement.buttonAdd')}
                      </Button>
                    </div>
                  )}
                <FormActions>
                  <Button onClick={this.handleSave} type="primary">
                    {t('info.saveBtnInfo')}
                  </Button>
                </FormActions>
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        <Modal
          title={t('info.addConsumerTitle')}
          open={consumerModalVisible}
          footer={null}
          onCancel={this.handleHideConsumerModal}
          destroyOnClose
        >
          <AddConsumer
            legalEntityId={legalEntityId || ownerId}
            closeModal={this.handleHideConsumerModal}
            isAdmin={isAdmin}
            initialValues={this.state.editConsumerData || {}}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

const getLoading = getLoadingSelector(
  selectors.getConsumptionPoint,
  selectors.getAvpPoints
);

const valueSelector = formValueSelector(FORM_ADD_CONSUMPTION_POINT);

const mapStateToProps = (state) => ({
  selectedGas: valueSelector(state, meteringPointFields.GAS),
  selectedPointId: selectors.getSelectedPointId(state),
  isLoading: getLoading(state),
  points: selectors.getAvpAndBmrPointsData(state),
  createFormVisible: selectors.isCreateFormShow(state),
  consumer: selectors.getConsumerData(state),
  consumerId: selectors.getConsumerId(state),
  userRole: getRole(state),
  consumerModalVisible: getAddConsumptionPointConsumerModal(state),
  ownerId: selectors.getOwnerId(state),
  legalEntityId: getUserLegalEntityId(state),
});

const mapDispatchToProps = {
  ...actions,
  showConsumerModal: showAddConsumptionPointConsumerModal,
  hideConsumerModal: hideAddConsumptionPointConsumerModal,
};

export default withTranslation(NAMESPACES.consumptionPointAdd)(
  connect(mapStateToProps, mapDispatchToProps)(ConsumptionPointAdd)
);
